<template>
  <v-row :no-gutters="isMobile">
    <!-- Left Selection Pane (Full width on mobile) -->
    <v-col :cols="isMobile ? 12 : 3" :class="{ 'mb-4': isMobile }">
      <slot name="selection-pane"></slot>
    </v-col>

    <!-- Main Content Area -->
    <v-col :cols="isMobile ? 12 : 9">
      <v-container fluid :class="isMobile ? 'px-4 pt-0 pb-16' : ''">
        <slot name="header-content"></slot>

        <div v-if="hasData">
          <!-- DESKTOP VIEW: Native Tabs -->
          <v-tabs
            v-if="!isMobile"
            v-model="activeTab"
            class="modern-tabs-container px-2 pt-2"
            active-class="active-gradient-tab elevation-3"
            slider-color="transparent"
            :color="getPrimaryColor"
            show-arrows
            grow
          >
            <v-tab
              v-for="(tab, index) in tabs"
              :key="'tab-' + index"
              class="modern-tab-item mx-1 my-1"
            >
              <v-icon left size="20" class="tab-icon">{{ tab.icon }}</v-icon>
              <span class="tab-text">{{ tab.label }}</span>
            </v-tab>
          </v-tabs>

          <!-- SHARED TAB CONTENT ITEMS -->
          <v-tabs-items v-model="activeTab">
            <v-tab-item
              v-for="(tab, index) in tabs"
              :key="'tab-content-' + index"
            >
              <!-- Dynamically renders the target Vue component -->
              <component
                :is="tab.component"
                v-bind="tab.props || {}"
                v-on="tab.on || {}"
              />
            </v-tab-item>
          </v-tabs-items>

          <!-- MOBILE VIEW: Always-Visible Bottom Navigation -->
          <v-bottom-navigation
            v-if="isMobile"
            v-model="activeTab"
            app
            fixed
            grow
            height="72"
            :color="getPrimaryColor || 'primary'"
            class="elevation-12 mobile-nav-bar"
          >
            <v-btn
              v-for="(tab, index) in tabs"
              :key="'nav-' + index"
              :value="index"
              class="custom-nav-btn"
            >
              <span class="nav-label">{{ tab.mobileLabel || tab.label }}</span>
              <v-icon size="26">{{ tab.icon }}</v-icon>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashShellComponent",
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getPrimaryColor() {
      return this.$store.getters.getPrimaryColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  props: {
    hasData: { type: Boolean, default: false },
    tabs: {
      type: Array,
      required: true,
      // Expected structure:
      // [{ label: 'Billing', mobileLabel: 'Billing', icon: 'mdi-cash', component: BillingComponent, props: {}, on: {} }]
    },
  },
  watch: {
    activeTab(newVal) {
      // Define which indexes are restricted (e.g., anything greater than 0)
      const freeTabsLimit = 0;

      if (newVal > freeTabsLimit) {
        this.checkPackageStatus();
      }
    },
  },
  data: () => ({
    activeTab: 0,
  }),
  methods: {
    checkPackageStatus() {
      if (!this.getUserCompany || this.getUserCompany.package === "freemium") {
        this.$store.commit("setUpgradeDialog", true);

        this.$nextTick(() => {
          this.activeTab = 0;
        });
        return;
      }
    },
  },
};
</script>

<style scoped>
.mobile-nav-bar {
  border-top: 2px solid rgba(0, 0, 0, 0.08);
}
.custom-nav-btn {
  height: 100% !important;
  padding: 6px 0 !important;
}
.custom-nav-btn .nav-label {
  display: block !important;
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em;
  margin-top: 2px;
  opacity: 0.85;
}
.custom-nav-btn.v-btn--active .nav-label {
  opacity: 1;
  font-size: 0.9rem !important;
}
.custom-nav-btn.v-btn--active .v-icon {
  transform: scale(1.15);
  transition: transform 0.2s ease;
}
</style>
